export const APPOINTMENT_CALENDAR_VIEWS = ['day', 'week', 'month', 'agenda'] as const;
export type AppointmentCalendarView = (typeof APPOINTMENT_CALENDAR_VIEWS)[number];

export interface AppointmentPageFilters {
  view: AppointmentCalendarView | null;
  date: string | null;
}

export const EMPTY_APPOINTMENT_FILTERS: AppointmentPageFilters = {
  view: null,
  date: null,
};

export function formatLocalDateParam(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseLocalDateParam(value: string | null | undefined): Date | null {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  const parsed = new Date(year, month - 1, day);
  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return null;
  }
  parsed.setHours(0, 0, 0, 0);
  return parsed;
}

export function parseAppointmentCalendarView(
  value: string | null | undefined,
): AppointmentCalendarView | null {
  if (!value) return null;
  return (APPOINTMENT_CALENDAR_VIEWS as readonly string[]).includes(value)
    ? (value as AppointmentCalendarView)
    : null;
}

export function parseAppointmentFiltersFromSearch(params: URLSearchParams): AppointmentPageFilters {
  return {
    view: parseAppointmentCalendarView(params.get('view')),
    date: parseLocalDateParam(params.get('date')) ? params.get('date') : null,
  };
}

export function appointmentFiltersToSearchParams(
  filters: AppointmentPageFilters,
  existing?: URLSearchParams,
): URLSearchParams {
  const params = existing ? new URLSearchParams(existing) : new URLSearchParams();
  if (filters.view) params.set('view', filters.view);
  else params.delete('view');
  if (filters.date) params.set('date', filters.date);
  else params.delete('date');
  return params;
}

export function appointmentReportToday(now: Date): AppointmentPageFilters {
  return { view: 'day', date: formatLocalDateParam(now) };
}

export function appointmentReportThisWeek(now: Date): AppointmentPageFilters {
  return { view: 'week', date: formatLocalDateParam(now) };
}
